import { Injectable } from '@angular/core';

import { SupplementModel } from '../../models/models';
import { ApiProvider } from '../api/api';

@Injectable()
export class SupplementProvider {
  private items: SupplementModel[] = [];

  constructor(
    private api: ApiProvider) {
  }

  Add(item: SupplementModel) {
    this.items.push(item);
  }

  Exists(item: SupplementModel): boolean {
    return this.items.find(x => {
      return x._id !== item._id && x.Name === item.Name && x.Brand === item.Brand;
    }) !== undefined;
  }

  Get(id) {
    return this.items.filter(x => x._id === id)[0];
  }

  List(): SupplementModel[] {
    return this.items;
  }

  Load(force: boolean = false) {
    return new Promise((resolve, reject) => {
      if (this.items.length === 0 || force) {
        this.LoadFromApi().then((data: SupplementModel[]) => {
          this.items = data;
          resolve(this.items);
        });
      }
      else {
        resolve(this.items);
      }
    });
  }

  Remove(item: SupplementModel) {
    return new Promise((resolve, reject) => {
      this.api.delete(`supplement/${item._id}`).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          this.items = this.items.filter(m => m._id !== item._id);
          resolve(this.items);
        }
      });
    });
  }

  Save(item: SupplementModel) {
    return new Promise((resolve, reject) => {
      const isNew = item._id === undefined;

      item._id = item._id || null;
      item.Notes = item.Notes || '';

      this.api.post('supplement/', item).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          item._id = data.id;

          if (isNew) {
            // add the item to the list
            this.items.push(item);
          }

          resolve(item);
        }
      });
    });
  }

  Sort(items: any = undefined) {
    if (!items) {
      items = this.items;
    }
    items.sort((a, b) => {
      if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
      else if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
      else return 0;
    });
    return items;
  }

  private LoadFromApi() {
    return new Promise((resolve, reject) => {
      this.api.get('supplement/').subscribe((data) => {

        const arr = data.json();

        let obj: SupplementModel[] = [];

        for(var j = 0; j < arr.length; j++) {
          var item = arr[j];

          obj.push({
            _id: item.id,
            Name: item.name,
            Brand: item.brand,
            Portion: item.portion,
            Notes: item.notes
          });          
        }

        resolve(obj);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/supplement/supplement.ts